module.exports = __webpack_public_path__ + "static/media/profit-report.b5478e72.svg";